import * as ApiEndpoint from './apiEndpoints';
import BaseBackend from './baseBackend';
import * as HttpMethod from './httpMethodConstants';
import { API_KEY, FILE_API_HOST, PROCUREMENT_API_HOST } from './api-config';
import { SPJ_ACTIONS } from '../utils';

export default class dentalCorpBackend extends BaseBackend {
	constructor() {
		super(PROCUREMENT_API_HOST, API_KEY);
	}

	setBaseUrl(host) {
		super.setBaseUrl(host);
	}

	async getStats(state, groupId, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = ApiEndpoint.STATS + `/${state.supplier.supplier}?groupId=${groupId}`;
		let response = await this._fetch(HttpMethod.GET, Endpoint, null, state.session.session_token, dispatch);
		return response;
	}

	async getSalesSummary(state, groupId, durationType, startDate, endDate, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = ApiEndpoint.SALES_SUMMARY + `/${state.supplier.supplier}?groupId=${groupId}&durationType=${durationType}&startDate=${startDate}&endDate=${endDate}`;
		let response = await this._fetch(HttpMethod.GET, Endpoint, null, state.session.session_token, dispatch);
		return response;
	}

	async getDSOList(state, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.SALES}${ApiEndpoint.DSO}/${state.supplier.supplier}`;
		let response = await this._fetch(HttpMethod.GET, Endpoint, null, state.session.session_token, dispatch);
		return response;
	}

	async getSalesByDate(state, startDate, endDate, status, page, size, custId = '', groupId = '', searchText = '', dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = ApiEndpoint.SALES + `/${state.supplier.supplier}?status=${status}&page=${page}&size=${size}&custId=${custId}&groupId=${groupId}&searchText=${searchText}`;
		if (startDate !== null && startDate !== undefined) {
			Endpoint += `&startDate=${startDate}`;
		}
		if (endDate !== null && endDate !== undefined) {
			Endpoint += `&endDate=${endDate}`;
		}
		let response = await this._fetch(HttpMethod.GET, Endpoint, null, state.session.session_token, dispatch);
		return response;
	}

	async getOrderById(state, orderId, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = ApiEndpoint.SALES + `/${state.supplier.supplier}/order/${orderId}`;
		let response = await this._fetch(HttpMethod.GET, Endpoint, null, state.session.session_token, dispatch);
		return response;
	}

	async updateOrderLines(state, orderId, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `/sales/${state.supplier.supplier}/order/${orderId}/orderlines`;
		let response = await this._fetch(HttpMethod.PUT, Endpoint, body, state.session.session_token, dispatch);
		return response;
	}

	async updateUser(state, body, dispatch) {
		let Endpoint = ApiEndpoint.UPDATE_USER;
		let response = await this._fetchDentira(HttpMethod.POST, Endpoint, body, state.session.session_token, 10000, dispatch);
		return response;
	}

	async logoutUser(state, dispatch) {
		let Endpoint = ApiEndpoint.LOGOUT;
		let response = await this._fetchDentira(HttpMethod.POST, Endpoint, null, state.session.session_token, 10000, dispatch);
		return response;
	}

	async fetchInventoryItems(state, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch);
		return response;
	}

	async updateStatus(state, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/update`;
		let response = await this._fetch(HttpMethod.PUT, Endpoint, body, state.session.session_token, dispatch);
		return response;
	}

	async updateBucketPrice(state, source, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/update/${source}`;
		let response = await this._fetch(HttpMethod.PUT, Endpoint, body, state.session.session_token, dispatch);
		return response;
	}

	async fetchBucketList(state, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.SUPPLIER_BUCKETS}/${state.supplier.supplier}`;
		let response = await this._fetch(HttpMethod.GET, Endpoint, null, state.session.session_token, dispatch);
		return response;
	}

	async createBucket(state, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.SUPPLIER_BUCKETS}/${state.supplier.supplier}`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch);
		return response;
	}

	async cloneBucket(state, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.SUPPLIER_BUCKETS}/${state.supplier.supplier}/clone`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch);
		return response;
	}

	async updateBucket(state, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.SUPPLIER_BUCKETS}/${state.supplier.supplier}`;
		let response = await this._fetch(HttpMethod.PUT, Endpoint, body, state.session.session_token, dispatch);
		return response;
	}

	async deleteBucket(state, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.SUPPLIER_BUCKETS}/${state.supplier.supplier}`;
		let response = await this._fetch(HttpMethod.DELETE, Endpoint, body, state.session.session_token, dispatch);
		return response;
	}

	async fetchDSOList(state, page, size, searchText, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.DSO}/${state.supplier.supplier}?page=${page}&size=${size}&search=${searchText}`;
		let response = await this._fetch(HttpMethod.GET, Endpoint, null, state.session.session_token, dispatch);
		return response;
	}

	async mapDSO(state, dsoId, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.DSO}/${state.supplier.supplier}/${dsoId}`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch);
		return response;
	}

	async updateDSOConfig(state, dsoId, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.DSO}/${state.supplier.supplier}/${dsoId}`;
		let response = await this._fetch(HttpMethod.PUT, Endpoint, body, state.session.session_token, dispatch);
		return response;
	}

	async fetchFileUploadURL(state, app, extension, folder, dispatch) {
		let Endpoint = `${ApiEndpoint.FETCH_FILE_UPLOAD_URL}?app=${app}&extension=${extension}&folder=${folder}`;
		let response = await this._fetchCustomBase(FILE_API_HOST, HttpMethod.GET, Endpoint, null, state.session.session_token, dispatch);
		return response;
	}

	async uploadFile(state, url, data, type, dispatch) {
		let response = await this._uploadFileCustomBase(url, HttpMethod.PUT, '', data, type, state.session.session_token, 60000, dispatch);
		return response;
	}

	async fetchAutocompleteManufacturer(state, body, search, size, dispatch) {
		let Endpoint = `${ApiEndpoint.FETCH_AUTOCOMPLETE_MANUFACTURER}?search=${search}&size=${size}`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch, false, 120000);
		return response;
	}

	async fetchAutocompleteManufacturerV2(state, body, search, size, dispatch) {
		let Endpoint = `${ApiEndpoint.FETCH_AUTOCOMPLETE_MANUFACTURER_V2}?search=${search}&size=${size}`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch, false, 120000);
		return response;
	}

	async fetchAutocompleteMappedSupplier(state, body, search, size, dispatch) {
		let Endpoint = `${ApiEndpoint.FETCH_AUTOCOMPLETE_SUPPLIER}?search=${search}&size=${size}`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch, false);
		return response;
	}

	async fetchAutocompletePackaging(state, body, search, size, dispatch) {
		let Endpoint = `${ApiEndpoint.FETCH_AUTOCOMPLETE_PACKAGING}?search=${search}&size=${size}`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch, false);
		return response;
	}

	async fetchAutocompleteMappedDSO(state, body, search, size, dispatch) {
		let Endpoint = `${ApiEndpoint.FETCH_AUTOCOMPLETE_GROUP_IDS}?search=${search}&size=${size}`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch, false);
		return response;
	}

	async fetchAutocompleteCategory(state, body, search, size, dispatch) {
		let Endpoint = `${ApiEndpoint.FETCH_AUTOCOMPLETE_CATEGORY}?search=${search}&size=${size}`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch, false);
		return response;
	}

	async fetchAutocompleteSubCategory(state, body, search, size, dispatch) {
		let Endpoint = `${ApiEndpoint.FETCH_AUTOCOMPLETE_SUBCATEGORY}?search=${search}&size=${size}`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch, true);
		return response;
	}

	async fetchAutocompleteSubSubCategory(state, body, search, size, dispatch) {
		let Endpoint = `${ApiEndpoint.FETCH_AUTOCOMPLETE_SUBSUBCATEGORY}?search=${search}&size=${size}`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch, true);
		return response;
	}

	async fetchAutocompleteCategoryV2(state, body, search, size, dispatch) {
		let Endpoint = `${ApiEndpoint.FETCH_AUTOCOMPLETE_CATEGORY_V2}?search=${search}&size=${size}`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch, false);
		return response;
	}

	async fetchAutocompleteSubCategoryV2(state, body, search, size, dispatch) {
		let Endpoint = `${ApiEndpoint.FETCH_AUTOCOMPLETE_SUBCATEGORY_V2}?search=${search}&size=${size}`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch, true);
		return response;
	}

	async fetchAutocompleteSubSubCategoryV2(state, body, search, size, dispatch) {
		let Endpoint = `${ApiEndpoint.FETCH_AUTOCOMPLETE_SUBSUBCATEGORY_V2}?search=${search}&size=${size}`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch, true);
		return response;
	}

	async createInventory(state, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/create`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch);
		return response;
	}

	async fetchInventory(state, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/fetch`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch);
		return response;
	}

	async updateInventory(state, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/update`;
		let response = await this._fetch(HttpMethod.PUT, Endpoint, body, state.session.session_token, dispatch);
		return response;
	}

	async deleteInventory(state, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/delete`;
		let response = await this._fetch(HttpMethod.DELETE, Endpoint, body, state.session.session_token, dispatch);
		return response;
	}

	// AI-rejected/DLQ-failed items only exist for ingestion-pipeline (v2) suppliers - see
	// sellerportal's routes/inventory.js '/:supplier/rejected*' routes.
	async fetchRejectedInventoryItems(state, page, size, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/rejected?page=${page}&size=${size}`;
		let response = await this._fetch(HttpMethod.GET, Endpoint, null, state.session.session_token, dispatch);
		return response;
	}

	async fetchAllRejectedInventoryItems(state, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/rejected?all=true`;
		let response = await this._fetch(HttpMethod.GET, Endpoint, null, state.session.session_token, dispatch);
		return response;
	}

	async clearRejectedInventoryItem(state, supplierProductId, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/rejected/${supplierProductId}`;
		let response = await this._fetch(HttpMethod.DELETE, Endpoint, null, state.session.session_token, dispatch);
		return response;
	}

	async clearAllRejectedInventoryItems(state, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/rejected`;
		let response = await this._fetch(HttpMethod.DELETE, Endpoint, null, state.session.session_token, dispatch);
		return response;
	}

	async addBulkItems(state, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/bulk`;
		let response = await this._uploadFile(HttpMethod.POST, Endpoint, body, null, state.session.session_token, 60000, dispatch, false);
		return response;
	}

	async updateBulkItemsAndStatus(state, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/bulk-update`;
		let response = await this._uploadFile(HttpMethod.POST, Endpoint, body, null, state.session.session_token, 60000, dispatch, false);
		return response;
	}

	async updateBulkBucketPrices(state, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/bulk-multiple-price`;
		let response = await this._uploadFile(HttpMethod.POST, Endpoint, body, null, state.session.session_token, 60000, dispatch, false);
		return response;
	}

	async fetchSPJBatchJobs(state, page = 1, size = 10, batch_id = '', status = '', event = '', row = '', dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.FETCH_SPJ}/${state.supplier.supplier}?page=${page}&size=${size}&batch_id=${batch_id}&status=${status}&event=${event}&row=${row}`;
		let { response: resp } = await this._fetch(HttpMethod.GET, Endpoint, null, state.session.session_token, dispatch, false);
		if (resp) {
			return resp;
		}
	}

	async fetchSPJBatchMetric(state, batch_id = '', dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.FETCH_SPJ}/${state.supplier.supplier}/batches/${batch_id}`;
		let { response: resp } = await this._fetch(HttpMethod.GET, Endpoint, null, state.session.session_token, dispatch, false);
		if (resp) {
			return resp;
		}
	}

	async fetchSPJActiveBatches(state, status = '', event = '', dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.FETCH_SPJ}/${state.supplier.supplier}/batches?status=${status}&event=${event}`;
		let { response: resp } = await this._fetch(HttpMethod.GET, Endpoint, null, state.session.session_token, dispatch, false);
		if (resp) {
			return resp;
		}
	}

	async clearSPJFailed(state, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.FETCH_SPJ}/${state.supplier.supplier}/failed-jobs`;
		let { response: resp } = await this._fetch(HttpMethod.DELETE, Endpoint, body, state.session.session_token, dispatch, false);
		if (resp) {
			return resp;
		}
	}

	async downloadSPJErrors(state, action, batch_id, dispatch) {
		const fileName = `${action} errors.xlsx`;
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.FETCH_SPJ}/${state.supplier.supplier}/failed-jobs/${batch_id}`;
		return await this._fetchBlob(this.API_BASE_URL, HttpMethod.GET, Endpoint, null, state.session.session_token, fileName, 60000, dispatch, false);
	}

	async downloadTemplateFile(state, action, body, dispatch) {
		const fileName = `Bulk-${action}-template.xlsx`;
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = '';
		switch (action) {
			case SPJ_ACTIONS.INVENTORY_CREATE:
			case SPJ_ACTIONS.LAB_INVENTORY_CREATE:
				Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/bulk-create/template`;
				return await this._fetchBlob(this.API_BASE_URL, HttpMethod.GET, Endpoint, null, state.session.session_token, fileName, 60000, dispatch, false);
			case SPJ_ACTIONS.INVENTORY_UPDATE:
			case SPJ_ACTIONS.LAB_INVENTORY_UPDATE:
				Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/bulk-update/template`;
				return await this._fetchBlob(this.API_BASE_URL, HttpMethod.GET, Endpoint, null, state.session.session_token, fileName, 60000, dispatch, false);
			case SPJ_ACTIONS.PRICE_UPDATE:
				Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/bulk-multiple-price/template`;
				return await this._fetchBlob(this.API_BASE_URL, HttpMethod.POST, Endpoint, body, state.session.session_token, fileName, 60000, dispatch, false);
			case SPJ_ACTIONS.INVENTORY_DELETE:
				Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/bulk-delete/template`;
				return await this._fetchBlob(this.API_BASE_URL, HttpMethod.GET, Endpoint, body, state.session.session_token, fileName, 60000, dispatch, false);
			case SPJ_ACTIONS.INVENTORY_DELETE_INDEX:
				Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/bulk-delete-index/template`;
				return await this._fetchBlob(this.API_BASE_URL, HttpMethod.GET, Endpoint, body, state.session.session_token, fileName, 60000, dispatch, false);
			default:
				break;
		}
	}

	async uploadFilledTemplateFile(state, action, body, onSuccess, onFailure, dispatch) {
		try {
			if (!(state.supplier && state.supplier.supplier)) {
				return null;
			}
			let Endpoint = '';
			switch (action) {
				case SPJ_ACTIONS.INVENTORY_CREATE:
				case SPJ_ACTIONS.LAB_INVENTORY_CREATE:
					Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/bulk`;
					break;
				case SPJ_ACTIONS.INVENTORY_UPDATE:
				case SPJ_ACTIONS.LAB_INVENTORY_UPDATE:
					Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/bulk-update`;
					break;
				case SPJ_ACTIONS.PRICE_UPDATE:
					Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/bulk-multiple-price`;
					break;
				case SPJ_ACTIONS.LAB_SKU_PRICE_UPDATE:
					Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/bulk-sku-price`;
					break;
				case SPJ_ACTIONS.SALES_ORDER_UPDATE:
					Endpoint = `${ApiEndpoint.SALES}/${state.supplier.supplier}/orderlines/upload`;
					break;
				case SPJ_ACTIONS.INVENTORY_DELETE:
					Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/bulk-delete`;
					break;
				case SPJ_ACTIONS.INVENTORY_DELETE_INDEX:
					Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/bulk-delete-index`;
				default:
					break;
			}
			let { response: resp } = await this._uploadFile(HttpMethod.POST, Endpoint, body, null, state.session.session_token, 60000, dispatch, false);
			if (resp) {
				onSuccess(resp);
			}
		} catch (err) {
			onFailure(err);
		}
	}

	async downloadInventoryData(state, action, body, dispatch) {
		const fileName = `${action}.xlsx`;
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/download`;
		return await this._fetchBlob(this.API_BASE_URL, HttpMethod.POST, Endpoint, body, state.session.session_token, fileName, 60000, dispatch, false);
	}

	async downloadInventoryPrices(state, action, body, dispatch) {
		const fileName = `${action}.xlsx`;
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/bulk-multiple-price/template`;
		return await this._fetchBlob(this.API_BASE_URL, HttpMethod.POST, Endpoint, body, state.session.session_token, fileName, 60000, dispatch, false);
	}

	async downloadSalesByDate(state, action, startDate, endDate, status, custId = '', groupId = '', searchText = '', downloadTrackingTemplate, dispatch) {
		const fileName = `${action}.xlsx`;
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint =
			ApiEndpoint.SALES +
			`/${state.supplier.supplier}/download?status=${status}&custId=${custId}&groupId=${groupId}&searchText=${searchText}&downloadTrackingTemplate=${downloadTrackingTemplate}`;
		if (startDate !== null && startDate !== undefined) {
			Endpoint += `&startDate=${startDate}`;
		}
		if (endDate !== null && endDate !== undefined) {
			Endpoint += `&endDate=${endDate}`;
		}
		return await this._fetchBlob(this.API_BASE_URL, HttpMethod.GET, Endpoint, null, state.session.session_token, fileName, 60000, dispatch, false);
	}

	async getAllSuppliers(sessionToken, dispatch) {
		let Endpoint = ApiEndpoint.GET_ALL_SUPPLIERS;
		let response = await this._fetch(HttpMethod.GET, Endpoint, null, sessionToken, dispatch);
		return response;
	}

	async getSupplierMap(sessionToken, body, dispatch) {
		let Endpoint = ApiEndpoint.GET_SUPPLIER_MAP;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, sessionToken, dispatch);
		return response;
	}

	async fetchDentiraMapping(state, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/dentira-mapping/fetch`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch);
		return response;
	}

	async addDentiraMapping(state, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/dentira-mapping/add`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch);
		return response;
	}

	async updateDentiraMapping(state, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/dentira-mapping/update`;
		let response = await this._fetch(HttpMethod.PUT, Endpoint, body, state.session.session_token, dispatch);
		return response;
	}

	async removeDentiraMapping(state, body, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.INVENTORY}/${state.supplier.supplier}/dentira-mapping/delete`;
		let response = await this._fetch(HttpMethod.DELETE, Endpoint, body, state.session.session_token, dispatch);
		return response;
	}

	async fetchAutocompleteDentiraProducts(state, category, search, size, page, addOns, dispatch) {
		let Endpoint = `${ApiEndpoint.FETCH_AUTOCOMPLETE_DENTIRA_PRODUCTS}?category=${category}&search=${search}&size=${size}&page=${page}&add_ons=${addOns}`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, {}, state.session.session_token, dispatch, true);
		return response;
	}

	async fetchAutocompleteDentiraPrimaryProducts(state, params, body, dispatch) {
		let Endpoint = `${ApiEndpoint.FETCH_AUTOCOMPLETE_DENTIRA_PRIMARY_PRODUCTS}?page=${params?.page}&size=${params?.size}&searchTxt=${params?.searchTxt||''}`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch, true);
		return response;
	}

	async fetchAutocompleteDentiraAddOnsProducts(state, params, body, dispatch) {
		let Endpoint = `${ApiEndpoint.FETCH_AUTOCOMPLETE_DENTIRA_ADDONS_PRODUCTS}?page=${params?.page}&size=${params?.size}&searchTxt=${params?.searchTxt||''}`;
		let response = await this._fetch(HttpMethod.POST, Endpoint, body, state.session.session_token, dispatch, true);
		return response;
	}

	async fetchDentiraProductCategories(state, addOns, dispatch) {
		let Endpoint = `${ApiEndpoint.FETCH_DENTIRA_PRODUCT_CATEGORIES}?add_ons=${addOns}`;
		let response = await this._fetch(HttpMethod.GET, Endpoint, {}, state.session.session_token, dispatch, false);
		return response;
	}

	async fetchDentiraProductFilters(state, filters, dispatch) {

		let Endpoint = `${ApiEndpoint.FETCH_DENTIRA_PRODUCT_FILTERS}`;
	
		// Append query params only if filters exist
		if (filters && (filters.procedure || filters.subProcedure || filters.material)) {
			const queryParams = [];
	
			if (filters.procedure) {
				queryParams.push(`procedure_type=${encodeURIComponent(filters.procedure)}`);
			}
			if (filters.subProcedure) {
				queryParams.push(`sub_procedure=${encodeURIComponent(filters.subProcedure)}`);
			}
			// if (filters.material) {
			// 	queryParams.push(`material=${encodeURIComponent(filters.material)}`);
			// }
	
			if (queryParams.length) {
				Endpoint += `?${queryParams.join('&')}`;
			}
		}
		let response = await this._fetch(HttpMethod.GET, Endpoint, null, state.session.session_token, dispatch);
		return response;
	}
	async getLabRebateConfig(state, labId, dispatch) {
		if (!labId) {
			return null;
		}
		if (!state || !state.session || !state.session.session_token) {
			return null;
		}
		let Endpoint = `${ApiEndpoint.GET_LAB_REBATE_CONFIG}/${labId}`;
		try {
			let response = await this._fetch(HttpMethod.GET, Endpoint, null, state.session.session_token, dispatch, true, 10000);
			return response;
		} catch (error) {
			console.error('getLabRebateConfig: Error occurred:', error);
			return null;
		}
	}

	async fetchRecommendedAiSkuMappings(state, page = 1, size = 10, dispatch) {
		if (!(state.supplier && state.supplier.supplier)) {
    		return null;
        }
  		let Endpoint = `${ApiEndpoint.FETCH_RECOMMENDED_AI_SKU_MAPPINGS}/${state.supplier.supplier}?page=${page}&size=${size}`;
		try{
			let response = await this._fetch(HttpMethod.GET, Endpoint, null, state.session.session_token, dispatch);
			return response;
		} catch (error) {
			console.error('fetchRecommendedAiSkuMappings: Error occurred:', error);
			return null;
		}
	}

	async approveAiSkuMappingRecommendation(state, body, dispatch) {
		try{
			if (!(state.supplier && state.supplier.supplier)) {
				return null;
			}
			const { createMapping, ...rest } = body
			let Endpoint = `${ApiEndpoint.FETCH_RECOMMENDED_AI_SKU_MAPPINGS}/approve?createMapping=${createMapping}`;
			let response = await this._fetch(HttpMethod.POST, Endpoint, rest, state.session.session_token, dispatch);
			return response;
		} 
		catch (error) {
			console.error('approveAiSkuMappingRecommendation: Error occurred:', error);
			return null;
		}
	}
	
	async rejectAiSkuMappingRecommendation(state, body, dispatch) {
		try{
			if (!(state.supplier && state.supplier.supplier)) {
				return null;
			}
			const { deleteMapping, ...rest } = body
			let Endpoint = `${ApiEndpoint.FETCH_RECOMMENDED_AI_SKU_MAPPINGS}/reject?deleteMapping=${deleteMapping}`;
			let response = await this._fetch(HttpMethod.POST, Endpoint, rest, state.session.session_token, dispatch);
			return response;
		}
		catch (error) {
			console.error('rejectAiSkuMappingRecommendation: Error occurred:', error);
			return null;
		}
	}	
}
